
export class ClientDetails {}

export class ClientDetailsRequest {}
